import React from "react"

import { t } from "i18next"

import { useAutoplayVideosSetting } from "../hooks/use-autoplay-videos-setting"
import SettingsFieldset from "./settings-fieldset"
import SettingsRow from "./settings-row"
import Switch from "./switch"
import { SwitchContainer } from "./switch-container"

export function SettingsAutoplayVideos(): React.JSX.Element {
  const [setting, setSetting] = useAutoplayVideosSetting()

  return (
    <SettingsFieldset id="autoplay-videos" title={t("Playback")}>
      <SettingsRow label={t("Autoplay next video")}>
        <SwitchContainer>
          <Switch value={setting} onValueChange={setSetting} />
        </SwitchContainer>
      </SettingsRow>
    </SettingsFieldset>
  )
}
